import { render } from "./CategoryPage2.vue?vue&type=template&id=43b1ce7c"
import script from "./CategoryPage2.vue?vue&type=script&lang=js"
export * from "./CategoryPage2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__